<template>
  <div>
     <div class="title-dialog">
      <p style="font-size: 30px; font-family: Roboto; font-weight: 100;">{{$t('change_password')}}</p>
    </div>
      
    <div class="icon-close">
      <b-icon stacked icon="x" @click="closeDialog()" scale="1.1" class="style-x" v-b-tooltip.hover title="Fechar" ></b-icon>
    </div>

    <div class="wrapper-resetpwd">
      
      <div>
        <b-form>

          <b-form-group
            id="input-group-2"
            :label="$t('pwd_current')"
            label-for="input-2"
            label-class = "label-form"
          >
            <b-form-input
              id="input-2"
              v-model="passwordCurrent"
              type="password"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-3"
            :label="$t('pwd_new')"
            label-for="input-3"
            label-class = "label-form"
          >
            <b-form-input
              id="input-3"
              v-model="newPassword"
              type="password"
              required
            ></b-form-input>
          </b-form-group>
          <p v-if="erro" class="erro-msg"> {{$t('message_error_invalid_email_and_pwd')}} </p>
        

        <div class="d-flex flex-row-reverse">
          <b-button @click="changePassword()" class="btn_atos-submit btn_log_in">
            {{$t('btn_change')}}
            <b-spinner  v-if="showSpinner" variant="light" small></b-spinner>
          </b-button>
        </div>

        </b-form>
      </div>
        
      <md-dialog :md-active.sync="showDialog" class="confirmDialog">
        <md-dialog-title>{{$t('change_password')}}</md-dialog-title>
        <div class="box-message-dialog">
          <span> {{ this.msgInfo }} </span>
          <md-icon class="md-size-2x" v-bind:class="{ 'check-nok' : erro , 'check-ok' : !erro }" >{{icon}}</md-icon>
        </div>

        <md-dialog-actions> 
          <md-button class="md-primary" @click="closeDialog()">OK</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>

  </div>
</template>

<script>
import firebase from '@/firebaseInit.js';
import i18n from '@/i18n.js'

export default {
  name: 'Login',
  props: ['origin'],
  components: {

  },
   data: () => ({
   
    passwordCurrent: '',
    newPassword: '',
    showDialog: false,
    msgInfo: '',
    erro: false,
    icon:'',
    showSpinner: false,
  }),

  methods: {
    changePassword: function(){
        this.erro = false;
        this.msgInfo = '';
        this.icon= '';
        this.showDialog = false;
        var currentUser = null;
       
        currentUser = firebase.auth().currentUser;
        if(this.newPassword != ''){
          currentUser.updatePassword(this.newPassword)
          this.msgInfo = i18n.t('message_successfully_pwd_changed');
          this.icon = 'check_circle_outline'
          this.showDialog = true;
        }
        else{
          this.erro = true;
          this.msgInfo = i18n.t('message_error_pwd_changed');
          this.icon = 'error';
          this.showDialog = true;
        }
        
    },
    closeDialog(){
      this.showDialog = false;
      this.$emit('showDialogChangePwd', false )
    }
  }
}
</script>

<style lang="scss" scoped>

.wrapper-resetpwd{
  color: #fff;
  width: 435px;
  padding: 100px 20px 30px 20px;
}
 



</style>
